__turbopack_context__.v({
  "_stable": "Select-module-scss-module__kyosKa___stable",
  "app_light_theme": "Select-module-scss-module__kyosKa__app_light_theme",
  "fadeIn": "Select-module-scss-module__kyosKa__fadeIn",
  "fadeOut": "Select-module-scss-module__kyosKa__fadeOut",
  "input_container": "Select-module-scss-module__kyosKa__input_container",
  "input_container__arrow": "Select-module-scss-module__kyosKa__input_container__arrow",
  "input_container__icon": "Select-module-scss-module__kyosKa__input_container__icon",
  "input_container__input": "Select-module-scss-module__kyosKa__input_container__input",
  "input_container__value": "Select-module-scss-module__kyosKa__input_container__value",
  "input_container__value__placeholder": "Select-module-scss-module__kyosKa__input_container__value__placeholder",
  "options": "Select-module-scss-module__kyosKa__options",
  "options__list": "Select-module-scss-module__kyosKa__options__list",
  "root": "Select-module-scss-module__kyosKa__root",
  "root__adaptive": "Select-module-scss-module__kyosKa__root__adaptive",
  "root__clear": "Select-module-scss-module__kyosKa__root__clear",
  "root__disabled": "Select-module-scss-module__kyosKa__root__disabled",
  "root__error": "Select-module-scss-module__kyosKa__root__error",
  "root__mobileModal": "Select-module-scss-module__kyosKa__root__mobileModal",
  "root__open": "Select-module-scss-module__kyosKa__root__open",
  "root__searchable": "Select-module-scss-module__kyosKa__root__searchable",
});
